angular
    .module('app')
    .component('badgesList', {
        templateUrl: '/templates/pages/badges/badgesList/badgesList.html',
        controller: 'BadgesListController',
        controllerAs: 'vm',
    });